import { render, staticRenderFns } from "./guard_config_view.vue?vue&type=template&id=b0a70336&scoped=true"
import script from "./guard_config_view.vue?vue&type=script&lang=js"
export * from "./guard_config_view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0a70336",
  null
  
)

export default component.exports